import axios from "axios";

export type Email = string;
export type AuthJWT = string;

export enum Priority {
    LOW = "LOW",
    MEDIUM = "MEDIUM",
    HIGH = "HIGH",
    CRITICAL = "CRITICAL",
}

export interface User {
    id: string;
    name?: string;
    email: Email;
    sites: UserSite[];
    notificationForPriority?: Priority;
}

export interface UserSite {
    siteId: string;
    siteName: string;
}

export interface UpdateUserCommand {
    name: string;
    notificationForPriority?: Priority;
}

export const login = async (accessToken: string) => {
    const response = await axios.post("/api/user/login", { accessToken });

    if (response.status !== 204) {
        throw new Error("Login failed");
    }
}

export const testLogin = async (email: string) => {
    await axios.post("/api/user/test-login", { email });
}

export const getUser = async (): Promise<User | null> => {
    try {
        const response = await axios.get<User>("/api/user");
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 401) {
            return null;
        }
        throw error;
    }
}

export const updateUser = async (command: UpdateUserCommand): Promise<User> => {
    const response = await axios.post("/api/user", command);
    return response.data;
}

export const logout = async () => {
    await axios.post("/api/user/logout");
}